import axios from "axios";
import { ZOHO_SCOPES } from "../config/scope";
import {
  ADMIN_API_URL,
  DATA_CENTER_API_NAME,
  DATA_CENTER_URL_API_NAME,
  EXTENSION_IDENTIFIER,
  IS_SANDBOX,
  ORG_ID_API_NAME,
  ZOHO_CONN,
} from "../config/serviceConstant";
import {
  accountUrlMap,
  dataCenterMap,
  RELATEDLIST_WIDGET_TYPE,
  WIDGET_DESCRIPTION,
  WIDGET_NAME,
  WIDGET_URL,
} from "../config/zohoConstant";

export const setOrgId = async (ZOHO) => {
  try {
    const orgInfo = await ZOHO.CRM.CONFIG.getOrgInfo();
    const orgId = orgInfo?.org?.[0]?.id || "";
    const orgData = {
      apiname: ORG_ID_API_NAME,
      value: orgId,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", orgData);
    return orgId;
  } catch (error) {
    return error;
  }
};

export const setUpOrgVariable = async (ZOHO, variableKey, variableValue) => {
  try {
    const orgData = {
      apiname: variableKey,
      value: variableValue,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", orgData);
    return true;
  } catch (error) {
    return false;
  }
};

export const setUpDataCenterUrl = async (ZOHO) => {
  try {
    const currentEnv = await ZOHO.CRM.CONFIG.GetCurrentEnvironment();
    let dataCenterUrl = dataCenterMap?.[currentEnv?.deployment] || "";
    if (IS_SANDBOX === "true") {
      dataCenterUrl = `https://plugin-${EXTENSION_IDENTIFIER}.zohosandbox.com`;
    }
    const dataCenterData = {
      apiname: DATA_CENTER_URL_API_NAME,
      value: dataCenterUrl,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", dataCenterData);
    return dataCenterUrl;
  } catch (error) {
    return null;
  }
};

export const setUpDataCenter = async (ZOHO) => {
  try {
    const currentEnv = await ZOHO.CRM.CONFIG.GetCurrentEnvironment();
    const dataCenterData = {
      apiname: DATA_CENTER_API_NAME,
      value: currentEnv?.deployment,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", dataCenterData);

    return currentEnv?.deployment;
  } catch (error) {
    return null;
  }
};

export const getOrgVariable = async (ZOHO, variableKey) => {
  try {
    const variableValue = await ZOHO.CRM.API.getOrgVariable(variableKey);
    return variableValue?.Success?.Content || null;
  } catch (error) {
    return null;
  }
};

const getAccountUrl = (countryCode) => {
  return accountUrlMap[countryCode];
};

export const getZohoAuthUrl = async (zohoBody) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/auth/zoho/authenticate",
      data: {
        orgId: zohoBody?.orgid,
        apiKey: zohoBody?.apikey,
        zapiKey: zohoBody?.zapikey,
        accountsUrl: getAccountUrl(zohoBody?.dataCenter),
        connName: ZOHO_CONN,
        scope: ZOHO_SCOPES,
        redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
        crmApiDomain: zohoBody?.datacenterurl,
      },
    };

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.authUrl;
  } catch (error) {
    return null;
  }
};

export const checkZohoAuth = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/verifyauth",
      headers: zohoHeaders,
    };

    const authCheck = await axios(config);

    if (authCheck?.data?.org?.length > 0) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const verifyZohoAuthAndCreateRelatedListWidget = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/verifyauth",
      headers: zohoHeaders,
    };
    const authCheck = await axios(config);
    if (!authCheck?.data?.org?.length) {
      return { isAuthenticated: false, isRelatedListCreated: false };
    }

    try {
      let config = {
        url: `${ADMIN_API_URL}/data/zoho/crm/extwidgets`,
        method: "POST",
        data: {
          widgetName: WIDGET_NAME,
          widgetUrl: WIDGET_URL,
          widgetDescription: WIDGET_DESCRIPTION,
          widgetType: RELATEDLIST_WIDGET_TYPE,
          apiDomain: zohoHeaders?.datacenterurl,
        },
        headers: zohoHeaders,
      };
      const createExtension = await axios.request(config);
      console.log({ createExtension });
      return { isAuthenticated: true, isRelatedListCreated: true };
    } catch (error) {
      return { isAuthenticated: true, isRelatedListCreated: false };
    }
  } catch (error) {
    return { isAuthenticated: false, isRelatedListCreated: false };
  }
};

export const revokeZoho = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/revoke",
      headers: zohoHeaders,
    };

    const revokeCheck = await axios(config);
    if (revokeCheck?.data || !revokeCheck?.error) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const getAllActiveUsersAndCurrentUser = async (ZOHO) => {
  try {
    let users = await ZOHO.CRM.API.getAllUsers({ Type: "ActiveUsers" });
    let currentUserResp = await ZOHO.CRM.CONFIG.getCurrentUser();
    return { allUsers: users?.users, currentUser: currentUserResp?.users?.[0] };
  } catch (error) {
    return null;
  }
};
